'use client';

import { ShowStyles } from '@/enums/show-styles';
import { useApplyLayoutContext } from '@/hooks/state/layout';
import { normalizeMediaFileUrl } from '@/utils/media-file-url';
import { Movie } from '@cinemark/content-api-client';
import Image from 'next/image';
import { MovieMediaCarouselComponent } from './movie-media-carousel';

type MovieDetailMediaProps = {
  dataLinkCategory: string;
  movie: Movie;
};

export const MovieDetailMedia = ({ dataLinkCategory, movie }: Readonly<MovieDetailMediaProps>): React.JSX.Element | null => {
  const poster = movie.posterLargeImage || movie.posterMediumImage || movie.posterSmallImage;
  const posterUrl = poster?.url ? normalizeMediaFileUrl(poster.url) : undefined;
  const hasPoster = !!(poster && posterUrl);
  const hasMovieMedia = !!movie.trailers?.some(trailer => trailer.thumbnailHighResUrl || trailer.thumbnailUrl)
    || !!movie.stillImagesLarge?.some(image => image.url);

  useApplyLayoutContext(false, ShowStyles.MainTightHeader);

  if (!hasPoster && !hasMovieMedia) {
    return null;
  }

  return (
    <div className="w-full flex flex-col gap-ms">
      <div className="flex flex-col md:items-center gap-md md:flex-row">
        {hasPoster &&
          <Image alt={`${movie.movieTitle} Poster`}
            className="hidden w-[300px] h-[450px] rounded-md md:block"
            height={poster!.height}
            src={posterUrl!}
            width={poster!.width}
          />
        }

        <MovieMediaCarouselComponent dataLinkCategory={`Carousel|${dataLinkCategory}`}
          movie={movie}
        />
      </div>
    </div>
  );
};
